<template>
  <div class="pa-2 k-field-group">
    <v-row>
      <v-col :cols="labelsize" :class="labelcolclass">
        <label class="field-label" :for="name"
          ><span v-html="name"></span>
          <v-tooltip v-if="tooltip" :text="tooltip">
            <template v-slot:activator="{ props }">
              <i v-bind="props" class="fal fa-info-circle"></i>
            </template>
          </v-tooltip>
        </label>
      </v-col>
      <v-col :cols="slotsize" class="my-auto ml-auto d-flex">
        <slot></slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    props: {
      name: String,
      tooltip: String,
      labelcolclass: {
        type: String,
        default: "my-auto",
      },
      labelsize: {
        value: Number,
        default: 6,
      },
      slotsize: {
        value: Number,
      },
    },
  };
</script>

<style>
  .k-field-group {
    .field-label {
      font-size: 1.3rem !important;
      opacity: 0.6;
    }
  }
</style>
